import React from 'react'
import { Grid } from '@material-ui/core'
import TemplateName from '../TemplateName'
import Subject from '../Subject'
import language from 'utils/vast-languagepack'

export default ({ mobile, emailCardSelected }) => {
  return (
    <div
      style={{
        marginTop: 5,
        height: '100%',
        backgroundColor: '#fff',
        padding: mobile ? 12 : 0,
        width: '100%',
      }}
    >
      {emailCardSelected === 'sms' ? (
        <div style={{ width: '100%' }}>
          <TemplateName
            helperText={
              language.templatePage.templateFormPage.helperText.addTitle
            }
          />
        </div>
      ) : (
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <TemplateName
              helperText={
                language.templatePage.templateFormPage.helperText.addTitle
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Subject
              helperText={
                language.templatePage.templateFormPage.helperText.subjectLine
              }
            />
          </Grid>
        </Grid>
      )}
    </div>
  )
}
